import { render } from "./Program.vue?vue&type=template&id=1a98909c&scoped=true&ts=true"
import script from "./Program.vue?vue&type=script&lang=ts"
export * from "./Program.vue?vue&type=script&lang=ts"

import "./Program.vue?vue&type=style&index=0&id=1a98909c&scoped=true&lang=scss"
import "./Program.vue?vue&type=style&index=1&id=1a98909c&lang=scss"

import exportComponent from "/Users/lihui/Desktop/project/student_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a98909c"]])

export default __exports__